import comSpSkeleton from "../../../engines/components/comSpSkeleton";
import O1HD from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import utilsView from "../../../engines/libs/utilsView";
import { MessageEventKind } from "../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../BundleResourceConfig";
import NormalGameManager from "../manager/NormalGameManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class level67 extends cc.Component {
    private readonly soundTimeMap: { [name: string]: number } = {
        // "level67/chunbianduo": 4.4,
        // "level67/dougeijun": 3.3,
        // "level67/jun": 1.5,
        // "level67/junnvyiqi": 7.2,
        // "level67/junsanmiao": 3.6,
        // "level67/nan": 4,
        // "level67/nanbianshuzhihousanmiao": 6.7,
        // "level67/nv": 2.1,
        // "level67/nvsanmiao": 2.7

        "chunbianduo": 0,
        "dougeijun": 0,
        "jun": 0,
        "junnvyiqi": 0,
        "junsanmiao": 0,
        "nan": 0,
        "nanbianshuzhihousanmiao": 0,
        "nv": 0,
        "nvsanmiao": 0
    }
    @property({ type: cc.Node, displayName: "需要操作的所有字节点" })
    fonts: cc.Node[] = []

    @property({ type: cc.Node, displayName: "树的生成的碰撞点" })
    treeCreateTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "树的右边碰撞点" })
    treeRightTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "树的右下碰撞点" })
    treeRightDownTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "树的右下碰撞点" })
    junRightTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "君节点" })
    junNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "女节点" })
    nvNode: cc.Node = null;

    private moveSpeed: number = 400;

    private audioId: number = null;

    @property({ type: cc.Node, displayName: "树的节点" })
    treeNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "红豆子数组" })
    ormosias: cc.Node[] = [];

    private fontCanHandler: boolean = true;

    onLoad() {
        this.startAni();
        this.initLevel();
    }

    initLevel() {
        for (let i = 0; i < this.fonts.length; i++) {
            let n = this.fonts[i];
            n.on('touchstart', this.onTouchFontStart, this);
            n.on('touchmove', this.onTouchFontMove, this);
            n.on('touchend', this.onTouchFontEnd, this);
            n.on('touchcancel', this.onTouchFontEnd, this);
        }
        for (let i = 0; i < this.ormosias.length; i++) {
            let n = this.ormosias[i];
            n.on('touchstart', this.onOrmosiaStart, this);
            n.on('touchmove', this.onOrmosiaMove, this);
            n.on('touchend', this.onOrmosiaEnd, this);
            n.on('touchcancel', this.onOrmosiaEnd, this);
        }
    }

    nanPos: cc.Vec2 = null;
    chunPos: cc.Vec2 = null;
    junPos: cc.Vec2 = null;
    nvPos: cc.Vec2 = null;

    onTouchFontStart(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "nan": {
                this.nanPos = n.getPosition().clone();
                break;
            }
            case "chun": {
                this.chunPos = n.getPosition().clone();
                break;
            }
            case "jun": {
                this.junPos = n.getPosition().clone();
                break;
            }
            case "nv": {
                this.nvPos = n.getPosition().clone();
                break;
            }
        }
    }

    onTouchFontMove(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "nan": {
                this.nanPos && this.onNanMove(e);
                break;
            }
            case "chun": {
                this.chunPos && this.onChunMove(e);
                break;
            }
            case "jun": {
                this.junPos && this.onJunMove(e);
                break;
            }
            case "nv": {
                this.nvPos && this.onNvMove(e)
                break;
            }
        }
    }

    onTouchFontEnd(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "nan": {
                this.nanPos && this.onNanEnd(e);
                break;
            }
            case "chun": {
                this.chunPos && this.onChunEnd(e);
                break;
            }
            case "jun": {
                this.junPos && this.onJunEnd(e);
                break;
            }
            case "nv": {
                this.nvPos && this.onNvEnd(e);
                break;
            }
        }
    }

    //南的状态 0表示普通状态  1表示已经到左下位置（即可以往上拉生成红豆树） 2表示红豆树已经生成
    nanState: number = 0;
    canMoveNan: boolean = true;
    onNanMove(e: cc.Event.EventTouch) {
        if (!this.canMoveNan) {
            return;
        }
        let nan: cc.Node = e.target;
        let detal: cc.Vec2 = e.getDelta();
        if (this.nanState == 1) {
            let ly = e.getLocationY();
            let sy = e.getStartLocation().y;
            console.log(ly, sy, "怎么回事?????")
            if (ly - sy > 100) {
                O1HD.getManagers().soundMgr.playSound("nanbianshu",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                let nanAniNode = nan.getChildByName("XiangSi");
                let nanLb = nan.getChildByName("label");
                nanAniNode.active = true;
                nanLb.active = false;
                nan.targetOff(this);
                let nanAni = nanAniNode.getComponent(comSpSkeleton);
                O1HD.getManagers().soundMgr.playSound("nanbianshu",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                nanAni.playAnimation("Nan_Bian").onComplete(1, () => {
                    this.playSound("nanbianshuzhihousanmiao");
                    this.scheduleOnce(this.nanbianshuthree, 4);
                    this.treeChuXian();
                    nan.active = false;
                }).start(false);
                this.nanState = 2;
            }
        } else {
            nan.x += detal.x;
            nan.y += detal.y;
        }
    }

    onNanEnd(e: cc.Event.EventTouch) {
        let nan: cc.Node = e.target;
        let detal = e.getDelta();
        let nanTrigger = nan.getChildByName("nanTrigger");
        if (this.nanState == 0) {
            if (this.treeCreateTrigger.getBoundingBoxToWorld().intersects(nanTrigger.getBoundingBoxToWorld())) {
                this.nanState = 1;
                let p = this.treeCreateTrigger.convertToWorldSpaceAR(cc.v2());
                let pos = nan.parent.convertToNodeSpaceAR(p);
                let time = pos.sub(nan.getPosition()).mag() / this.moveSpeed;
                this.canMoveNan = false;
                //@ts-ignore
                cc.tween(nan).to(time, { position: pos }).call(() => {
                    this.canMoveNan = true;
                    this.playSound("nan");
                }).start();
            } else {
                nan.setPosition(this.nanPos);
            }
        } else {
            nan.setPosition(this.nanPos);
        }
    }

    //春字的状态 0表示普通状态 1表示已经拖到树的右方 2表示已经滑动完了
    chunState: number = 0;

    chunX: number = 0;

    huaCount: number = 0;

    onChunMove(e: cc.Event.EventTouch) {

        let chun: cc.Node = e.target;
        let detal = e.getDelta();
        if (this.nanState != 2) {
            chun.x += detal.x;
            chun.y += detal.y;
            return;
        }
        if (this.chunState == 0) {
            chun.x += detal.x;
            chun.y += detal.y;
        } else if (this.chunState == 1) {
            // this.chunX = this.chunX;
            chun.x += detal.x;
            chun.y += detal.y;

            if (chun.x < this.chunX && chun.getBoundingBoxToWorld().intersects(this.treeNode.getBoundingBoxToWorld())) {
                this.chunX = chun.x;
            }
            console.log(chun.x - this.chunX, chun.x, this.chunX, chun.getBoundingBoxToWorld().intersects(this.treeNode.getBoundingBoxToWorld()));
            if (chun.x - this.chunX > 40 && chun.getBoundingBoxToWorld().intersects(this.treeNode.getBoundingBoxToWorld())) {
                // 滑了一次
                console.log("滑了一次");
                this.chunX = chun.x;
                this.huaCount++;
                if (this.huaCount >= 5) {
                    this.playSound("chunbianduo");
                    chun.targetOff(this);
                    this.unschedule(this.nanbianshuthree);
                    this.ormosiaShow(() => {
                        cc.tween(chun).to(0.3, { opacity: 0 }).start();
                    });

                    this.chunState = 2;
                }
            }
        }
    }

    onChunEnd(e: cc.Event.EventTouch) {
        let chun: cc.Node = e.target;
        this.huaCount = 0;
        if (this.nanState != 2) {
            chun.setPosition(this.chunPos);
            return;
        }
        if (this.chunState == 0) {
            if (chun.getBoundingBoxToWorld().intersects(this.treeRightTrigger.getBoundingBoxToWorld())) {
                let p = this.treeRightTrigger.getPosition()
                // let pos = chun.parent.convertToNodeSpaceAR(p);
                let time = p.sub(chun.getPosition()).mag() / this.moveSpeed;
                //@ts-ignore
                cc.tween(chun).to(time, { position: p }).start();
                this.chunState = 1;
            } else {
                chun.setPosition(this.chunPos);
            }
        } else {
            chun.setPosition(this.chunPos);
        }
    }

    //君的状态 0表示普通状态 1表示已经拖到树下 2表示
    junState: number = 0;
    junLa: boolean = false;
    onJunMove(e: cc.Event.EventTouch) {
        let jun: cc.Node = e.target;
        let detal = e.getDelta();
        if (this.chunState != 2) {
            jun.x += detal.x;
            jun.y += detal.y;
            return;
        }
        if (this.junState == 0) {
            jun.x += detal.x;
            jun.y += detal.y;
        } else if (this.junState == 2) {
            let sPosX = e.getStartLocation().x;
            let ePosX = e.getLocationX();
            if (sPosX - ePosX < -10 && this.nvState == 1) {
                this.junLa = true;
                // if(this.nvLa){
                this.winAni();
                // }
            }
        }
    }

    onJunEnd(e: cc.Event.EventTouch) {
        let jun: cc.Node = e.target;
        if (this.chunState != 2) {
            jun.setPosition(this.junPos);
            return;
        }
        if (this.junState == 0) {
            if (jun.getBoundingBoxToWorld().intersects(this.treeRightDownTrigger.getBoundingBoxToWorld())) {
                this.junState = 1;
                let p = this.treeRightDownTrigger.getPosition()
                // let pos = jun.parent.convertToWorldSpaceAR(p);
                let time = p.sub(jun.getPosition()).mag() / this.moveSpeed;
                this.playSound("jun");
                this.scheduleOnce(this.junThree, 4.5);
                // this.junThree();
                //@ts-ignore
                cc.tween(jun).to(time, { position: p }).call(() => {
                    this.scheduleOnce(() => {
                        let junAni = jun.getChildByName("XiangSi");
                        let junlb = jun.getChildByName("label");
                        junAni.active = true;
                        junlb.active = false;
                        junAni.getComponent(comSpSkeleton).playAnimation("Jun_TanQi").start(false);
                        this.scheduleOnce(() => {
                            O1HD.getManagers().soundMgr.playSound("juntanqi",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                        }, 0.1);
                    }, 1.4);
                }).start();
            } else {
                jun.setPosition(this.junPos);
            }
        } else {
            jun.setPosition(this.junPos);
        }
        this.junLa = false;
    }

    //女的状态
    nvState: number = 0;
    nvLa: boolean = false;
    onNvMove(e: cc.Event.EventTouch) {
        let nv: cc.Node = e.target;
        let delta = e.getDelta();
        if (this.junState != 2) {
            nv.x += delta.x;
            nv.y += delta.y;
        } else {
            if (this.nvState == 0) {
                nv.x += delta.x;
                nv.y += delta.y;
            } else if (this.nvState == 1) {
                let sPosX = e.getStartLocation().x;
                let ePosX = e.getLocationX();
                if (sPosX - ePosX > 10) {
                    this.nvLa = true;
                    // if(this.junLa){
                    // 君女靠在一起
                    this.winAni();
                    // }
                }
            }
        }
    }

    onNvEnd(e: cc.Event.EventTouch) {
        let nv: cc.Node = e.target;
        if (this.junState != 2) {
            nv.setPosition(this.nvPos);
            return;
        }
        if (this.nvState == 0) {
            if (nv.getBoundingBoxToWorld().intersects(this.junRightTrigger.getBoundingBoxToWorld())) {
                let p = this.junRightTrigger.getPosition();
                let time = nv.getPosition().sub(p).mag() / this.moveSpeed;
                this.playSound("nv");
                this.scheduleOnce(this.nvThree, 5);
                //@ts-ignore
                cc.tween(nv).to(time, { position: p }).start();
                this.nvState = 1;
            } else {
                nv.setPosition(this.nvPos);
            }
        } else {
            nv.setPosition(this.nvPos);
        }
        this.nvLa = false;
    }

    async playSound(name) {
        if (this.audioId != null) {
            O1HD.getManagers().soundMgr.stopSound(this.audioId);
        }
        this.audioId = await O1HD.getManagers().soundMgr.playSound(name,null,BUNDLE_SMALL_NAME.antiphonalVerse);
        const delay: number = this.soundTimeMap[name];
        if (delay) {
            this.fontCanHandler = false;
            this.scheduleOnce(() => {
                this.fontCanHandler = true;
            }, delay);
        }
    }

    nanbianshuthree() {
        // this.playSound("nanbianshuzhihousanmiao");
    }

    treeChuXian() {
        this.treeNode.active = true;
        this.treeNode.getComponent(comSpSkeleton).playAnimation("Nan_ShengZhang1").onComplete(1, () => {
        }).start(false);
        this.scheduleOnce(() => {
            this.ormosiaAni(this.ormosias[0]);
        }, 0.3);
    }

    ormosiaShow(call: () => void) {
        let treeAni = this.treeNode.getComponent(comSpSkeleton);

        treeAni.playAnimation("Nan_ShengZhang2").onComplete(1, () => {
        }).start(false);
        this.scheduleOnce(() => {
            this.ormosiaAni(this.ormosias[1]);
            treeAni.playAnimation("Nan_ShengZhang3").onComplete(2, () => {
            }).start(false);
            this.scheduleOnce(() => {
                this.ormosiaAni(this.ormosias[2]);
                treeAni.playAnimation("Nan_ShengZhang4").onComplete(3, () => {
                }).start(false);
                O1HD.getManagers().soundMgr.playSound("chunbashubianda",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                this.scheduleOnce(() => {
                    this.ormosiaAni(this.ormosias[3]);
                    call && call();
                }, 0.3);
            }, 0.3);
        }, 0.3);


    }

    ormosiaAni(node: cc.Node) {
        // console.log(node)
        node.active = true;
        node.opacity = 0;
        cc.tween(node).to(0.3, { opacity: 255 }).start();
    }

    ormosiaPosMap = {};

    //红豆点击
    onOrmosiaStart(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let node: cc.Node = e.target;
        let npos = node.getPosition().clone();
        this.ormosiaPosMap[node.uuid] = npos;
    }

    //红豆移动
    onOrmosiaMove(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let node: cc.Node = e.target;
        let detal = e.getDelta();
        node.x += detal.x;
        node.y += detal.y;
    }
    //红豆松开
    onOrmosiaEnd(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        console.log(this.junState, "???????????")
        let node: cc.Node = e.target;
        if (this.junState == 1) {
            if (node.getBoundingBoxToWorld().intersects(this.junNode.getBoundingBoxToWorld())) {
                this.playSound("dougeijun");
                let os = this.ormosias;
                for (let i = 0; i < os.length; i++) {
                    let o = os[i];
                    o.targetOff(this);
                }
                let p = this.junNode.getPosition().clone();
                p.x += 100;
                let time = p.sub(node.getPosition()).mag() / this.moveSpeed;
                //@ts-ignore
                cc.tween(node).to(0.3, { opacity: 0 }).start();
                this.junNode.getChildByName("XiangSi").getComponent(comSpSkeleton).playAnimation("Jun_NaDou").start(false);
                this.junState = 2;
                this.douNode = node;
                this.unschedule(this.junThree)
            } else {
                node.setPosition(this.ormosiaPosMap[node.uuid]);
            }
        } else {
            node.setPosition(this.ormosiaPosMap[node.uuid]);
        }
    }

    junThree() {
        this.playSound("junsanmiao")
    }

    nvThree() {
        this.playSound("nvsanmiao");
    }

    @property({ type: cc.Node, displayName: "爱心节点" })
    xinNode: cc.Node = null;

    douNode: cc.Node = null;

    winAni() {
        this.unschedule(this.nvThree);
        if (this.douNode) {
            cc.tween(this.douNode).to(0.3, { opacity: 0 }).start();
        }
        this.junNode.active = false;
        this.nvNode.getChildByName("label").active = false;
        this.nvNode.getChildByName("XiangSi").active = true;
        this.nvNode.getChildByName("XiangSi").getComponent(comSpSkeleton).playAnimation("Nv_TieTie").onComplete(1, () => {
            O1HD.getManagers().soundMgr.playSound("junnvkaozaiyiqi",null,BUNDLE_SMALL_NAME.antiphonalVerse);
            this.xinNode.active = true;
            this.xinNode.getComponent(sp.Skeleton).setAnimation(0, "animation", true);
            this.scheduleOnce(() => {
                this.playSound("junnvyiqi");
            }, 2);
            this.Win(10);
        }).start(false);

        // this.scheduleOnce(()=>{
        // },1);

        // cc.tween(this.junNode).to(1,{x:60}).start()
        // cc.tween(this.nvNode).to(1,{x:140}).call(()=>{
        // }).start();
    }

    @property({type:cc.Node,tooltip:"遮罩节点"})
    maskNode:cc.Node = null;

    startAni(){
        return new Promise<void>(resolve=>{
            cc.tween(this.maskNode).to(0.5,{width:2000,height:2000}).call(resolve).start();
        });
    }

    endAni(){
        return new Promise<void>(resolve=>{
            cc.tween(this.maskNode).to(0.5,{width:0,height:0}).call(resolve).start();
        });
    }

    async Win(delayTime:number){
        //  需完善
        this.scheduleOnce(async ()=>{
            await this.endAni();
            NormalGameManager._instance.setGameData({liBaiGoodValue:100});
            O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
            this.scheduleOnce(()=>{
                let addGoodsList = {};
                addGoodsList[50019] = 1;
                utilsView.openGetGoodsLayer(0, 0, addGoodsList);
                NormalGameManager._instance.onPushGoods(50019,1);
                this.node.destroy();
            },2);
        },delayTime);
    }

    goTips:boolean = false;

    @property({type:cc.Node,tooltip:"提示节点"})
    hintNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"ui节点"})
    uiNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示视频图标"})
    video:cc.Node = null;

    onBtnHint(){
        if(this.goTips){
            this.hintNode.active = true;
        }else{
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.goTips = true;
                this.hintNode.active = true;
                this.video.active = false;
            },()=>{

            },null,"对诗看广告获得提示");
        }
    }

    onBtnHintComit(){
        this.hintNode.active = false;
    }

    onBtnClose(){
        this.endAni().then(()=>{
            this.node.destroy();
        });
    }

}
